import { render } from "./ref-detail.vue?vue&type=template&id=5a30a278"
import script from "./ref-detail.vue?vue&type=script&lang=js"
export * from "./ref-detail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erdoganyesil/Sites/Fungi Turkey/FungiTurkey-Admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__